<template>
  <!-- 根据不同类型，设置不同背景图；点击时定位到输入框 -->
  <div class="custom-input" :style="{backgroundImage:'url('+picUrl+')'}" @click="focus($event)">
    <div class="custom-input-line"></div>
    <input class="custom-input-input" :class="inputLengthClass" :type="inputType" :placeholder="currentPlaceholder" v-model="content" @input="change($event)"/>
    <!-- 类型是密码框时，显示小眼睛；类型是验证码时，显示“发送验证码” -->
    <div v-if="type=='password'" class="custom-input-eye" :class="{'custom-input-eye-show':showPassword}" @click="showPassword=!showPassword"></div>
    <div v-else-if="type=='code'" class="custom-input-code-send" @click="getCode">发送验证码</div>
  </div>
</template>

<script>
  //获取不同背景图的地址
  import accountPic from "@/asset/img/account/account.png";
  import mobilePic from "@/asset/img/account/mobile.png";
  import codePic from "@/asset/img/account/code.png";
  import passwordPic from "@/asset/img/account/password.png";

  export default {
    name: "custom-input",
    data(){
      return{
        picUrl:"",
        //文本框长度的style对象
        inputLengthClass:{},
        currentPlaceholder:"",
        content:"",
        showPassword:false,
        isActive:false,
        //验证函数
        validFunc:{
          mobile:(value)=>{
            if(value.match(/^1\d{10}$/)){
              this.$emit("validate",{
                result:true
              })
            }
            else{
              this.$emit("validate",{
                result:false,
                msg:"请输入正确手机号"
              })
            }
          },
          password:(value)=>{
            if(value.match(/^\S{6,16}$/)){
              this.$emit("validate",{
                result:true
              })
            }
            else{
              this.$emit("validate",{
                result:false,
                msg:"请输入6-16位（数字、字母、_）密码"
              })
            }
          },
          code:(value)=>{
            if(value.match(/^\S{6}$/)){
              this.$emit("validate",{
                result:true
              })
            }
            else{
              this.$emit("validate",{
                result:false,
                msg:"请输入6位验证码"
              })
            }
          }
        }
      }
    },
    //type:mobile，password，code，account
    props:["type","placeholder","rules","value","mobile","codeType"],
    computed:{
      inputType(){
        if(this.type=='password' && !this.showPassword){
          return "password"
        }
        return "text";
      }
    },
    created(){
      switch(this.type){
        case 'mobile':
          this.picUrl=mobilePic;
          break;
        case 'account':
          this.picUrl=accountPic;
          break;
        case 'code':
          this.picUrl=codePic;
          this.inputLengthClass={"custom-input-input-code":true};
          break;
        case 'password':
          this.picUrl=passwordPic;
          this.inputLengthClass={"custom-input-input-password":true};
          break;
      }
      //如果调用组件时属性中没有placeholder，就用placeholderList中的
      if(this.placeholder){
        this.currentPlaceholder=this.placeholder;
      }
      else{
        var placeholderList={
          code:"请输入验证码",
          password:"请输入密码",
          mobile:"请输入手机号"
        };
        this.currentPlaceholder=placeholderList[this.type];
      }
    },
    methods:{
      focus(event){
        //已激活，直接退出
        if(this.isActive) return;

        var cTarget=event.currentTarget;
        cTarget.className+=' custom-input-focus';
        this.isActive=true;
        //点击其他地方后，取消掉文本框高亮
        var cancelActive=event=>{
          //如果对话框不包含点击的地方，也就是点击的不是对话框
          if(!this.tools.has(this.$el,event.target)){
            cTarget.className=cTarget.className.replace("custom-input-focus","");
            window.removeEventListener("click",cancelActive);
            this.isActive=false;
          }
        }
        window.setTimeout(function(){
          window.addEventListener("click",cancelActive)
        },0)
      },
      validate(){
        var ruleArr=this.rules.split("|");
        ruleArr.forEach((value,index)=>{
          this.validFunc[value](this.content);
        });
      },
      change(e){
        this.$emit('input',e.target.value);
      },
      getCode(){
        this.$api.get("",{
          api:"/v1/code/mobile",
          mobile:this.mobile,
          type:this.codeType
        },res=>{
          if(res.status){
            this.$emit("getCode",res.code.code);
            this.$toast("发送成功");
          }
        })
      }
    }
  }
</script>

<style scoped>
  .custom-input{
    width:9.147rem;
    height:1.12rem;
    margin:0.533rem auto 0 auto;
    border:1px solid #eee;
    background:0.627rem center no-repeat;
    background-size:0.8rem;
    border-radius: 8px;
  }
  .custom-input-focus{
    box-shadow:-0.027rem -0.027rem 0.267rem 0px rgba(0, 0, 0, 0.1);
  }
  .custom-input-line{
    float:left;
    height:0.587rem;
    margin-top:0.267rem;
    margin-left:2.107rem;
    border-left: 1px solid #eee;
  }
  .custom-input-input{
    float:left;
    width:6.4rem;
    height:100%;
    margin-left:0.307rem;
    font-size:0.373rem;
    border:0;
  }
  .custom-input-input-code{
    width:3.667rem;
  }
  .custom-input-input-password{
    width:5.067rem;
  }
  .custom-input-eye{
    float:right;
    height:100%;
    width:1.44rem;
    background:url("../../asset/img/account/password-hide.png") center center no-repeat;
    background-size:0.56rem;
  }
  .custom-input-eye-show{
    background-image:url("../../asset/img/account/password-show.png");
  }
  .custom-input-code-send{
    float:right;
    width:2.933rem;
    height:0.587rem;
    margin-top:0.267rem;
    text-align: center;
    line-height:0.587rem;
    color:#0c539b;
    font-size:0.373rem;
    border-left:1px solid #eee;
  }
</style>



// WEBPACK FOOTER //
// src/components/custom-input/custom-input.vue